import { render, staticRenderFns } from "./PaymentBatch.vue?vue&type=template&id=bc6d4f90&scoped=true"
import script from "./PaymentBatch.vue?vue&type=script&lang=js"
export * from "./PaymentBatch.vue?vue&type=script&lang=js"
import style0 from "./PaymentBatch.vue?vue&type=style&index=0&id=bc6d4f90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6d4f90",
  null
  
)

export default component.exports